/**
 * locale を正しい HTML lang 属性値 (BCP 47) に変換
 */
export const localeToHtmlLang = (locale: string): string => {
  const map: Record<string, string> = {
    ja: "ja",
    ja_kanji: "ja",
    en: "en",
    zh_tw: "zh-TW",
    zh_cn: "zh-CN",
  };
  return map[locale] || "ja";
};
